module.exports = __webpack_public_path__ + "media/assets/community/chevron-right-20854126ba471c86da3f49aae259e8443a52aae73018e0bbe1b07bc4d9340b95.png";